import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { AuthHeading, Spinner } from 'view/components';
import { AuthHeadingImageTypeEnums } from 'view/pages/auth/helpers';
import * as CS from 'view/pages/auth/commonStyled';
import { AuthFormsFooter } from 'view/pages/auth/components';
import { useChangeEmail } from 'view/pages/auth/hooks/useChangeEmail';

const ChangeEmailPage = () => {
  const navigate = useNavigate();

  const params = new URLSearchParams(window.location.search);
  const hash = params.get('hash');

  const { changeEmail, isLoading, error } = useChangeEmail();

  useEffect(() => {
    if (!hash) {
      navigate('/auth/login', { replace: true });
      return;
    }

    changeEmail({ hash });
  }, [hash]);

  return (
    <CS.Wrapper>
      <CS.AuthMainBox component="section">
        <AuthHeading
          title="Changing Email"
          subTitle={
            'Verifying your email and updating your account. \n You will be redirected to the login page shortly...'
          }
          imageType={AuthHeadingImageTypeEnums.LINE}
        />
        <CS.FormWrapper component="section" style={{ margin: '50px 0' }}>
          {isLoading && !error ? (
            <Spinner variant="outlined" />
          ) : (
            <div
              style={{
                color: '#942020',
                fontSize: '16px',
                fontWeight: 400,
                lineHeight: '22px',
                textAlign: 'center',
                whiteSpace: 'pre-line',
              }}
            >
              {error?.response?.data?.error && error?.response?.data?.message
                ? `${error?.response?.data?.error}. \n ${error?.response?.data?.message}`
                : 'Unexpected error. \n Please close this page and retry.'}
            </div>
          )}
        </CS.FormWrapper>
        <AuthFormsFooter
          title={
            'Having trouble? \n If your email change wasn’t successful,\n try updating it again in your profile settings.'
          }
          hrefText=""
        />
      </CS.AuthMainBox>
    </CS.Wrapper>
  );
};

export default ChangeEmailPage;
